import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "clients-panel" }
const _hoisted_2 = {
  key: 0,
  class: "clients-panel__no-access"
}
const _hoisted_3 = { class: "clients-panel__no-access-label" }

import {
	computed,
	ref,
	watch
} from "vue";
import {projectPageStore, ProjectContactsRequest} from "@/store/project-page";
import ProjectsBlockPanelFilters from "@/components/main/project-block-page/ProjectsBlockPanelFilters.vue";
import ProjectsBlockPanelList from "@/components/main/project-block-page/ProjectsBlockPanelList.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import { provideContactsContext } from "@/composables/useContactsContext";
import { useContactsAccess } from "@/composables/useContactsAccess";
import { RequestAddressContainer } from "@/composables/useAddressRequest";

type Option = {
	id: number | null,
	label: string,
	type: number,
	value: number | string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectBlockPageContacts',
  setup(__props) {

const projectStore = projectPageStore()
const { isContactsDenied, deniedText } = useContactsAccess()
const searchedContactId = ref<Option | null>(null)
const selectedTags = ref<TagWithFrequency[]>([])
const useUnion = ref(false)
const filters = ref({
	searchType: null as number | null,
	searchStr: '',
	inputContainer: null as RequestAddressContainer | null,
	toSkip: 0,
	count: 30
})
const appliedSearchText = ref('')

const project = computed(() => projectStore.openedProject)

const isUnionApplicable = computed(() => filters.value.searchType === 1)

const contactsTypesList = computed<Option[]>(() => {
	if (!project.value) return []

	const options: Option[] = [
		{
			id: null,
			label: "Все контакты проекта",
			type: 2,
			value: 'all-project'
		},
		{
			id: null,
			label: "Все контакты системы",
			type: 0,
			value: 'all-system'
		}
	]

	project.value?.AttachedClients?.forEach((client, index) => {
		options.push({
			id: client.Id,
			label: client.Name,
			type: 1,
			value: 100 + index
		})
	})

	return options
})

const buildRequest = (): ProjectContactsRequest => ({
	projectId: project.value!.Id,
	searchType: filters.value.searchType ?? 2,
	clientId: filters.value.searchType === 1
		? (searchedContactId.value?.id ?? undefined)
		: undefined,
	useUnion: filters.value.searchType === 1 ? useUnion.value : false,
	searchStr: filters.value.searchStr,
	inputContainer: filters.value.inputContainer,
	tags: selectedTags.value.length ? selectedTags.value.map(t => t.Id) : null,
	toSkip: filters.value.toSkip,
	count: filters.value.count,
})

const searchContacts = async (address?: RequestAddressContainer | null) => {
	if (!project.value) {
		return
	}

	if (address !== undefined) {
		filters.value.inputContainer = address
	}
	filters.value.searchType = searchedContactId.value?.type ?? 2
	filters.value.toSkip = 0
	appliedSearchText.value = filters.value.searchStr
	await projectStore.getContactsForProject(buildRequest())
}

const fetchPartial = async () => {
	if (
		projectStore.projectContactsLoading
		|| projectStore.projectContactsPartialLoading
		|| !projectStore.canLoadNextProjectContacts
	) return
	filters.value.toSkip += filters.value.count
	await projectStore.getContactsForProject(buildRequest())
}

const onChangeOption = async (option: Option) => {
	searchedContactId.value = option
	if (option.type !== 1) {
		useUnion.value = false
	}
	await searchContacts()
}

const onSelectedTagsUpdate = (next: TagWithFrequency[]) => {
	const wasEmpty = !selectedTags.value.length
	selectedTags.value = next
	if (!next.length && !wasEmpty) {
		searchContacts()
	}
}

const dropTag = (tag: TagWithFrequency) => {
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
	if (!selectedTags.value.length) {
		searchContacts()
	}
}

const onUseUnionChange = async (value: boolean) => {
	useUnion.value = value
	await searchContacts()
}

provideContactsContext({
	context: 'project',
	get projectId() {
		return projectStore.openedProject?.Id ?? null
	},
	get attachClientOptions() {
		return projectStore.openedProject?.AttachedClients ?? []
	},
	refetchContacts: () => searchContacts(),
})

watch(project, async (newVal) => {
	if (newVal) {
		filters.value.toSkip = 0
		selectedTags.value = []
		useUnion.value = false
		searchedContactId.value = {
			id: null,
			label: "Все контакты проекта",
			type: 2,
			value: 'all-project'
		}
		filters.value.searchType = 2
		await searchContacts()
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isContactsDenied))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppIcon, {
            class: "clients-panel__no-access-icon",
            name: "invalid",
            width: "24px",
            color: "#979797"
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(deniedText)), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(ProjectsBlockPanelFilters, {
            searchStr: filters.value.searchStr,
            "onUpdate:searchStr": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.searchStr) = $event)),
            searchedContactId: searchedContactId.value,
            "contacts-types": contactsTypesList.value,
            "selected-tags": selectedTags.value,
            "use-union": useUnion.value,
            "is-union-applicable": isUnionApplicable.value,
            onOnSearch: searchContacts,
            onUpdateSearchedContactId: onChangeOption,
            "onUpdate:selectedTags": onSelectedTagsUpdate,
            onDropTag: dropTag,
            "onUpdate:useUnion": onUseUnionChange
          }, null, 8, ["searchStr", "searchedContactId", "contacts-types", "selected-tags", "use-union", "is-union-applicable"]),
          _createVNode(ProjectsBlockPanelList, {
            onOnGetPartial: fetchPartial,
            "search-text": appliedSearchText.value
          }, null, 8, ["search-text"])
        ], 64))
  ]))
}
}

})